import { TSElementFactory } from "./TSElementFactory";

export default {
    __init__ : [
        'elementFactory'
    ],
    elementFactory: ['type', TSElementFactory]
}